import { useExponeaFloatingById } from "@sazka/casino/js/floating/use-floating";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { useAppInsights } from "@sazka/utils/logger/app-insights";

const expose = (name: string, method: (...args: any[]) => any) => {
    window.sazka.exponea[name] = method;
};

const showFloatingElement = (id: number) => {
    useExponeaFloatingById(id);
};

const reassignCurrentUserToGroups = async (...groupIds: number[]) => {
    try {
        await httpClient.post("/api/exponea/reassign-player", { gids: groupIds });
    } catch (e) {
        console.error(e);
        const message = `Reassign player from Exponea failed. GIDs: ${groupIds}`;
        useAppInsights().trackException(e as Error, {
            groupIds: groupIds.join(","),
            customMessage: message,
        });
    }
};

const assignCurrentUserToGroup = async (groupId: number) => {
    try {
        await httpClient.post("/api/exponea/assign-player", { gid: groupId });
    } catch (e) {
        console.error(e);
        const message = `Assign player from Exponea failed. GIDs: ${groupId}`;
        useAppInsights().trackException(e as Error, {
            groupId: groupId,
            customMessage: message,
        });
    }
};

const registerExponeaToWindow = (): void => {
    window.sazka = window.sazka || {};
    window.sazka.exponea = window.sazka.exponea || {};
    expose("showFloatingElement", showFloatingElement);
    expose("assignCurrentUserToGroups", reassignCurrentUserToGroups);
    expose("assignCurrentUserToGroup", assignCurrentUserToGroup);
};

export const useExponea = () => ({
    registerExponeaToWindow,
    expose,
});
